import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, Platform } from '@ionic/angular';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Api } from '../api/api';
import { MaintenancePage } from './pages/maintenance-page/maintenance.page';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
	static largeScreen = false;

	constructor(
		private route: ActivatedRoute,
		private auth: AngularFireAuth,
		private alertCtrl: AlertController,
		private snackbarCtrl: MatSnackBar,
		private router: Router,
		private analytics: AngularFireAnalytics,
		platform: Platform,
		private ccService: NgcCookieConsentService,
		private translate: TranslateService
	) {
		translate.setDefaultLang('de');
		translate.use('de');
		platform.ready().then(() => {
			AppComponent.largeScreen = platform.width() >= 992;
			platform.resize.subscribe(() => {
				AppComponent.largeScreen = platform.width() >= 992;
			});
		});
		ccService.statusChange$.subscribe(async event => {
			await this.setAnalyticsEnabled(event.status !== ccService.getStatus().deny);
		});
		this.setAnalyticsEnabled(!ccService.hasAnswered() || ccService.hasConsented());
		Api.isMaintenanceActive()
			.then(result => {
				if (result) {
					MaintenancePage.navigate(this.router);
				}
			})
			.catch(error => {
				console.log(error);
			});
	}

	ngOnInit() {
		this.translate //
			.get(['cookie.header', 'cookie.message', 'cookie.dismiss', 'cookie.allow', 'cookie.deny', 'cookie.link', 'cookie.policy'])
			.subscribe(data => {
				this.ccService.getConfig().content = this.ccService.getConfig().content || {};
				// Override default messages with the translated ones
				this.ccService.getConfig().content.message = data['cookie.message'];
				this.ccService.getConfig().content.dismiss = data['cookie.dismiss'];
				this.ccService.getConfig().content.allow = data['cookie.allow'];
				this.ccService.getConfig().content.deny = data['cookie.deny'];
				this.ccService.getConfig().content.link = data['cookie.link'];
				this.ccService.getConfig().content.policy = data['cookie.policy'];

				this.ccService.destroy(); // remove previous cookie bar (with default messages)
				this.ccService.init(this.ccService.getConfig()); // update config with translated messages
			});
	}

	async setAnalyticsEnabled(enabled: boolean) {
		await this.analytics.setAnalyticsCollectionEnabled(enabled);
	}
}
